import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { canonicalPath, pageForPath } from '../seo/pages.mjs';
import { applyHead } from '../seo/head.mjs';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      let id;
      try { id = decodeURIComponent(to.hash.slice(1)); } catch { return false; }
      const element = document.getElementById(id);
      if (element) return { el: element, top: 88 };
    }
    if (to.path !== from.path) return { top: 0 };
  },
  routes,
});

router.beforeEach(to => {
  const path = canonicalPath(to.path);
  if (path && path !== to.path) return { path, query: to.query, hash: to.hash, replace: true };
});
router.afterEach((to, from, failure) => {
  if (failure) return;
  applyHead(document, pageForPath(to.path), {
    noindex: document.documentElement.dataset.modeckNoindex === 'true' || !['modeck.io', 'www.modeck.io'].includes(window.location.hostname),
  });
});

export default router;
